import { Box, TextField } from "@mui/material"

export const EvaluationFooter = ({ value, setValue }) => {
	return (
		<Box sx={{ display: "flex", flexDirection: "column", gap: 2, p: 2, width: "100%" }}>
			<TextField
				label="Observaciones Generales"
				fullWidth
				multiline
				rows={4}
				value={value}
				onChange={(e) => {
					setValue(e.target.value)
				}}
			/>
		</Box>
	)
}
